export default "__VITE_ASSET__17cd4fde__"